var _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAthleteManagement = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1072,
    height: 1094,
    viewBox: "0 0 1072 1094",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ddd",
    width: 1072,
    height: 1094
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "rgba(0,0,0,0.5)",
    fontFamily: "sans-serif",
    fontSize: 30,
    dy: 10.5,
    fontWeight: "bold",
    x: "50%",
    y: "50%",
    textAnchor: "middle"
  }, "RAP placeholder")));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAthleteManagement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/athleteManagement.a9ca1b86fbb5f518dac3741ea692fa30.svg";